module.exports = __webpack_public_path__ + "static/img/teacher_1.391db8c4.png";